import React from 'react'
import AnalyticsBox from '../../../../../Influencer/AuthenticationsPageParts/OverviewParts/AnalyticsBox'
import CampaignInfluencerBottomNavBtns from './CampaignInfluencerBottomNavBtns'
import CampaignInfluencerProfileDetails from '../../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerProfileDetails'

export default function ProfileDetails({ auth }) {
  return (
    <CampaignInfluencerProfileDetails
      auth={auth}
      AnalyticsBoxComponent={AnalyticsBox}
      BottomNavComponent={CampaignInfluencerBottomNavBtns}
    />
  )
}